$(document).ready(function(){

  var temp = $('body').attr('temp');
  
  if($(window).width() >= 768) {
    $('.slideshow-i2-slide').remove();
  }
  
  if ($('.slideshow-slider').length) {
    var SliderSwiper = new Swiper('.slideshow-slider', {
      direction: 'vertical',
      speed: 1000,
      slidesPerView: 1,
      mousewheel: true,
      mousewheel: { 
        releaseOnEdges: true, 
      },
      observer: true,
      touchReleaseOnEdges: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  var init = false;
  var newArrival;
  function swipernewArrivalCard() {
      if (!init) {
        init = true;
        newArrival = new Swiper('.new-arrival-slider', {
          direction: 'horizontal',
          slidesPerView: 2,
          spaceBetween: 5,
          observer: true,
          touchReleaseOnEdges: true,
          // mousewheel: true,
          loop: true,
          speed: 400,
          breakpoints: {
            1200: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 3,
            }
          }
        });

        const categoriesSection = document.querySelector('.main-cate-arrival-wrap');
        if (categoriesSection) {
          const observerOptions = {
            threshold: 0.5 // 50% visibility
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (!newArrival) return;

              if (entry.isIntersecting) {
                // Start autoplay when section is visible
                newArrival.params.autoplay = { delay: 2000 };
                newArrival.autoplay.start();
              } else {
                // Stop autoplay when section is not visible
                newArrival.autoplay.stop();
              }
            });
          }, observerOptions);

          observer.observe(categoriesSection);
        }
      }
    
  }
  swipernewArrivalCard();
  window.addEventListener("resize", swipernewArrivalCard);



   var newArrivalCardMobile = new Swiper('.new-arrival-slider-mobile', {
    spaceBetween: 15,
    observer: true,
    slidesPerView: 2,
    slidesPerGroup: 2,
    touchReleaseOnEdges: true,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  var ProSwiperImg = new Swiper('.bc-sf-filter-img-slider', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var swiper = new Swiper('.site-promo-text', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 10000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });
  
  if($(window).width() >= 1024) {
    function slideshowHeight() {
      var slidesHeight = $('.slideshow-slider .slideshow-slide').length * $(window).innerHeight();
      $('.slideshow-wrapper').css({ 'height' : slidesHeight });
    }

    slideshowHeight();

    if ($('.slideshow-slider').length) {
      SliderSwiper.on('slideChange', function () {
        var offset = $('.slideshow-slide').innerHeight() * SliderSwiper.activeIndex;
        $(window).scrollTop(Math.abs(offset));
      });
    }

    if($('body').hasClass('index-page') && $('.slideshow-slider').length) {
      $(window).on('scroll', function(){
        slideshowHeight();
        var offset = ($('.slideshow-slider .slideshow-slide').length - 1) * $(window).innerHeight();
        if($(window).scrollTop() > offset) {
          $('body').addClass('slider-unsticked');
          SliderSwiper.mousewheel.disable();
        } else {
          $('body').removeClass('slider-unsticked');
          SliderSwiper.mousewheel.enable();
        }
      });
    }
  }

  if($('body').hasClass('index-page')) {
    window.onbeforeunload = function () {
      //window.scrollTo(0, 0);
    }
    
    var slideIndex = $('.slideshow-slider .slideshow-slide').eq(0).find('.slide-text-blocks').index();
    var default_color = $('.slideshow-slider .slideshow-slide').eq(slideIndex).find('.slide-text-blocks').attr('slide-color');
    if(typeof default_color !== 'undefined'){
      $('body').attr("data-slide-swatch", default_color);
    }
    //swatichColor(slideIndex);

    if ($('.slideshow-slider').length) {
      SliderSwiper.on('slideChange', function () {
        var slideIndex = SliderSwiper.activeIndex;
        swatichColor(slideIndex);
      });
    }

    function swatichColor(slideIndex){
      var colorClass = $('.slideshow-slider .slideshow-slide').eq(slideIndex).find('.slide-text-blocks').attr('slide-color');
      if(typeof colorClass !== 'undefined'){
        $('body').attr("data-slide-swatch", colorClass);
      }
    }

    $('.site-header-trans').mouseenter(function(){
      $(this).addClass('default-sticky');
    });

    $('.site-header-trans').mouseleave(function(){
      $(this).removeClass('default-sticky');
    });

    $(document).on('click', '.site-nav-trigger', function(){
      $(this).removeClass('default-sticky');
    });
  }


  // HG
  $("body").on("mouseenter touchstart", ".site-nav-link", function (e) {
      e.preventDefault();
      var menu = $(this);
      clearTimeout(window.navTimeout),
          (window.navTimeout = setTimeout(function () {
              $(".site-nav-link").removeClass("isMegaMenuLink--selected"),
              $(".site-nav-dropdown").removeClass("isMegaMenuVisible"),
              $("body").addClass("mega-menu-open"),$("body").addClass("isOverlayActive"),
              menu.addClass("isMegaMenuLink--selected").siblings(".site-nav-dropdown").addClass("isMegaMenuVisible");              
          }, 100));
  });
  $("body").on("mouseleave touchend", ".site-nav-link", function () {
      clearTimeout(window.navTimeout);
  });
  $("body").on("mouseleave", ".site-nav-menu ul", function (a) {
      return (window.navTimeout = setTimeout(function () {
          $(".site-nav-link").removeClass("isMegaMenuLink--selected"),
          $(".site-nav-dropdown").removeClass("isMegaMenuVisible"),
          $("body").removeClass("mega-menu-open");
          $("body").removeClass("isOverlayActive");
      }, 100));
  });
  $("body").on("mouseenter", ".site-nav-menu ul", function (a) {
      return clearTimeout(window.navTimeout);
  });
  document.querySelector(".site-nav-menu ul").addEventListener("mouseenter", function () {
      document.activeElement.blur();
  });

  // added by H
  $('.site-nav-trigger-lg').click(function() {    
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.site-nav-li').removeClass('hovered');
      $('body').removeClass('site-nav-hovered');
      if($('body').hasClass('index-page') && !$('body').hasClass('site-header-black')) {
        $('.site-i-header').addClass('site-header-trans');
      }
    } else {
      $(this).addClass('active');
      $('.site-nav-li').addClass('hovered');
      if($('.site-nav-li').find('.site-nav-dropdown').length > 0) {
        $('body').addClass('site-nav-hovered');
        $('.site-i-header').removeClass('site-header-trans');        
      }
    }
  });

  $(document).on('click', '.site-nav1-toggle', function(){
    $(this).toggleClass('active').parent('li').siblings('li').find('> .site-nav1-toggle').removeClass('active');
    $(this).parents('li').toggleClass('nav-active').siblings('li').removeClass('nav-active');
    $(this).next('.site-nav1-dropdown').slideDown().parent('li').siblings('li').find('> .site-nav1-dropdown').slideUp();
  });
  
  $(document).on('click', '.site-nav2-toggle', function(){
    $(this).toggleClass('active').parent('li').siblings('li').find('> .site-nav2-toggle').removeClass('active');
    $(this).parent('li').toggleClass('nav-active').siblings('li').removeClass('nav-active');
    $(this).next('.site-nav2-dropdown').slideDown().parent('li').siblings('li').find('> .site-nav2-dropdown').slideUp();
    if($(this).is('.site-sub2-link')) {
      if($(this).hasClass('active')) {
        $(this).removeClass('not-active');
      } else {
        $('.site-sub2-link').removeClass('not-active');
      }
    } else if($(this).is('.site-toggle-arrow')) {
      if($('.site-sub2-link').hasClass('active')) {
        $('.site-sub2-link.active').trigger('click');
      }
    }
  });

  $(document).on('click', '.site-nav-trigger', function(){
    if($('body').hasClass('site-nav-opened')) {
      $('body').removeClass('site-nav-opened');
      $('.site-navmob-menu').slideUp(300);
      $('.site-nav2-toggle').each(function(){
        if($(this).hasClass('active')) {
          $(this).trigger('click');
        }
      });
    } else {
      $('body').addClass('site-nav-opened');
      $('.bc-sf-pop-close').trigger('click');
      $('.site-navmob-menu').slideDown(300);
    }
  });

  Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
  });
  
  $('body').on('click touchstart', function () {
    const videoElement = document.getElementById('slideshow-block-video');
    if(videoElement !== null ){
      if (videoElement.playing) {
          // video is already playing so do nothing
      }
      else {
          // video is not playing so play video now
          videoElement.play();
      }
    }
  });

  $(document).on('click','.site-top-handle',function(){
    $(this).parents('.site-nav2-li').removeClass('nav-active');
    $(this).parents('.site-nav2-li').find('.site-nav1-link').removeClass('active');
    $(this).parents('.site-nav2-li').find('.site-nav1-toggle').removeClass('active');
  });

  $(document).on('click','.site-localize-top-handle',function(){
    $(this).parents('.disclosure').removeClass('localize-drop-open');
  });

  $(document).on('click','.site-back-handle',function(){
    $(this).parents('.site-sub2-li').removeClass('nav-active');
    $(this).parents('.site-sub2-li').find('.site-sub2-link').removeClass('active');
  });

   $(document).on('click','.site-menu-close',function(){
    $('body').removeClass('site-nav-opened');
    $('.site-navmob-menu').slideUp(300);
    $('.site-nav2-toggle').each(function(){
      if($(this).hasClass('active')) {
        $(this).trigger('click');
      }
    });
  });
  
  if($(window).width() <= 1023) {
    $(document).on('click', '.site-ft-title', function(){
      $(this).toggleClass('active').parent('.site-ft-blocks').siblings('.site-ft-blocks').find('.site-ft-title').removeClass('active');
      $(this).next('.site-ft-content').slideToggle().parent('.site-ft-blocks').siblings('.site-ft-blocks').find('.site-ft-content').slideUp();
    });
  }

  $(document).on('click', '.announcement_bar .close_bar', function(){
    $("html").addClass('closed-top-bar');
  });
  
  //  login page validation //
  $('.btn-login').on('click',function(){
    var form = $(this).closest('form');
    var useremail = form.find('.customer_email').val();
    var password = form.find('.customer_password').val(); 
    var email = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
    
    form.find('.input-error').text('');

    if(useremail == ''){
      form.find('.input-error').text("Email is required");
      form.find('.customer_email').focus();
      return false;
    }else if(!useremail.match(email)){
      form.find('.input-error').text("Valid email is required");
      form.find('.customer_email').focus();
      return false;
    }else if(password == ''){
      form.find('.input-error').text("Password is required");
      form.find('.customer_password').focus();
      return false;
    }else{
      form.find('.input-error').text('');
    }
  });
  
  
  // Forget Password validation //
  $('.btn_forget_pwd').on('click',function(){
    var form = $(this).closest('form');
    var useremail = form.find('.customer_email').val();
    var email = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
    
    form.find('.input-error').text('');

    if(useremail == ''){
      form.find('.input-error').text("Email is required");
      form.find('.customer_email').focus();
      return false;
    }else if(!useremail.match(email)){
      form.find('.input-error').text("Valid email is required");
      form.find('.customer_email').focus();
      return false;
    }else{
      form.find('.input-error').text('');
    }
  });
  
  // collection page 
  if($('.bc-sf-nav-selected').length) {
    setInterval(function(){
      if($('#bc-sf-filter-tree .bc-sf-filter-selection-wrapper').length) {
        var count = $('.bc-sf-filter-selection-wrapper .selected-item').length;
        $('.bc-sf-nav-selected').addClass('filter-has-sct');
        $('.bc-sf-filter-selection-wrapper h3 span').attr('data-count', count);
        $('.filter-i-trigger .flt-sct-txt .flt-count').text(count);
      } else {
        $('.bc-sf-nav-selected').removeClass('filter-has-sct');
        $('.bc-sf-filter-selection-wrapper h3 span').attr('data-count', '0');
        $('.filter-i-trigger .flt-sct-txt .flt-count').text('0');
      }
    });
  }
  
  $(document).on('click', '.filter-i-trigger', function() {
    $(this).toggleClass('active');
    $('body').toggleClass('filter-opened');
    $('html, body').animate({
      scrollTop: $('#bc-sf-coll-filter').offset().top
    }, 500);
  });

  const bcSfObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.classList?.contains('bc-sf-filter-block-content')) {
          node.style.display = 'none';
          node.closest('.bc-sf-filter-option-block')?.classList.remove('opened');
        }

        if (node.classList?.contains('bc-sf-filter-option-block')) {
          const content = node.querySelector('.bc-sf-filter-block-content');
          if (content) content.style.display = 'none';
          node.classList.remove('opened');
        }
      });
    });
  });

  bcSfObserver.observe(document.body, {
    childList: true,
    subtree: true
  });


  $(document).on('click', '.bc-sf-filter-option-block', function() {
  var $this = $(this);
  var $content = $this.find('.bc-sf-filter-block-content');

  if ($this.hasClass('opened')) {
    $content.stop(true, true).slideUp(300, function() {
      $this.removeClass('opened');
    });
  } else {
    $('.bc-sf-filter-option-block.opened').each(function() {
      var $open = $(this);
      $open.find('.bc-sf-filter-block-content').stop(true, true).slideUp(300, function() {
        $open.removeClass('opened');
      });
    });

    $this.addClass('opened');
    $content.stop(true, true).slideDown(300);

    $('.bc-sf-filter-handle2 .bc-sf-handle-txt').text($this.data('title'));
    $('#bc-sf-popup-filter').addClass('var-opened');

    // Adjust height after animation
    setTimeout(function() {
      var height = $content.innerHeight();
      $('#bc-sf-filter-tree').attr('data-height', height);
      $('#bc-sf-filter-options-wrapper').css({ 'height': height });
    }, 350);
  }
});
  
  $(document).on('click', '.bc-sf-pop-back', function() {
    $('.bc-sf-filter-option-block').removeClass('opened');
    $('#bc-sf-popup-filter').removeClass('var-opened');
    $('#bc-sf-filter-options-wrapper').css({ 'height': 'auto' });
  });

  $(document).on('click', '.flt-i-sort', function() {
    $(this).parents('.bc-sf-sort-content-wrap').toggleClass('active');
    $(".bc-sf-filter-custom-sorting > label").click();
    $('body').removeClass('sort-opened');
  });
  
  
  if(temp.indexOf('collection') != -1){
    var scrollstop;
    $(window).scroll(function() {
      clearTimeout(scrollstop);
      $('.filter-i-trigger').removeClass('col-scroll-end').addClass('col-scroll-start');
      scrollstop = setTimeout(function() {
        $('.filter-i-trigger').addClass('col-scroll-end').removeClass('col-scroll-start');
      }, 250);
    });
  }
  
  function filterSticky() {
    var scrollTop = $(window).scrollTop(),
        offset = $('.site-i-header').innerHeight() + $('.filter-i-trigger').innerHeight(),
        offsetScroll = $(window).scrollTop() + offset,
        offset2 = $('.collection-page').offset().top + $('.collection-page').innerHeight();
    offsetScroll >= offset2 ? $('body').addClass('sticked-bottom') : $('body').removeClass('sticked-bottom');
  }
  
  if($('.filter-i-trigger').length > 0) {
    filterSticky();
    $(window).on('scroll', function() {
      filterSticky();
    });
  }

  $(document).on('click', '.flt-sub-link', function() {
    $(this).toggleClass('active');
  });
  
  $(document).on('click', '.bc-sf-filter-selection-wrapper .selected-item', function() {
    $('.bc-sf-filter-option-block').removeClass('opened');
    $('#bc-sf-popup-filter').removeClass('var-opened');
    $('#bc-sf-filter-options-wrapper').css({ 'min-height': 'auto' });
  });

  $(document).on('click', '.bc-sf-pop-close, .filter-i-mask', function() {
    $('body').removeClass('filter-opened');
    $('body').removeClass('sort-opened');
    setTimeout(function(){
      $('.bc-sf-filter-option-block').removeClass('opened');
      $('#bc-sf-popup-filter').removeClass('var-opened');
      $('#bc-sf-filter-options-wrapper').css({ 'min-height': 'auto' });
    }, 300);
  });

  $(document).on('click', '.bc-sf-sort-pop-close', function() {
    $('body').removeClass('sort-opened');
    // setTimeout(function(){
    //   $('.bc-sf-filter-option-block').removeClass('opened');
    //   $('#bc-sf-popup-filter').removeClass('var-opened');
    //   $('#bc-sf-filter-options-wrapper').css({ 'min-height': 'auto' });
    // }, 300);
  });
  
  // $(document).on('click', '.collapse-i-title', function() {
  //   $(this).toggleClass('active');
  //   $(this).next('.collapse-i-content').slideToggle();
  // });
  
  $(document).on('click', '.scroll-top-back', function() {
    $('html, body').animate({ scrollTop : 0 }, 300);
  });
  
  function scrollToTop() {
    if($('.scroll-top-back').length > 0 && $('.collection-i-list .bc-sf-filter-product-item').length > 12) {
      var scrollTop = $(window).scrollTop() + $(window).innerHeight();
      var offset = $('.bc-sf-filter-product-item:nth-child(13)').offset().top;
      if(scrollTop > offset) {
        $('.scroll-top-back').addClass('showed');
      } else {
        $('.scroll-top-back').removeClass('showed');
      }
    }
  }
  
  scrollToTop();
  $(window).on('scroll', function() {
    scrollToTop();
  });
  
  // var email = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
  // // newsletter validation
  // $('.newsletter-btn').on('click',function(){
  //   var form = $(this).closest('form');
  //   var input_email = form.find('.news-i-input').val();
  //   form.find('.form-i-error').text("");
  //   if(input_email == ''){
  //     form.find('.form-i-error').text('Email is required');
  //     form.find('.news-i-input').focus();
  //     return false;
  //   }
  //   else if(!input_email.match(email)){
  //     form.find('.form-i-error').text('Valid email is required');
  //     form.find('.news-i-input').focus();
  //     return false;
  //   }
  //   else{
  //     form.find('.form-i-error').text('');
  //   }
  // });


  var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  $('.newsletter-btn').on('click', function (e) {
    e.preventDefault();

    var form = $(this).closest('form');
    var email = form.find('.news-email').val().trim();
    var name = form.find('.news-name').val().trim();
    var policyChecked = form.find('#newscheck').is(':checked');

    var errorBox = form.find('.news-error');

    errorBox.text('');

    if (email === '') {
      errorBox.text('Email is required');
      return;
    }

    if (!emailRegex.test(email)) {
      errorBox.text('Please enter a valid email');
      return;
    }

    if (!policyChecked) {
      errorBox.text('Please accept the Privacy Policy');
      return;
    }

    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: form.serialize(),
      timeout: 6000,

      success: function () {
        form.find('.newsletter-drawer-middle, .newsletter-drawer-footer').hide();

        form.append(
          `<div class="newsletter-succues-div" >
            <p>You’re almost done!<br> Check your inbox and confirm your subscription.</p>
            <a href="/collections/all" class="btn btn-border news-follow-btn">CONTINUE SHOPPING</a>
          </div>`

        );
      },

      error: function () {
        errorBox.html(
          'Verification required. ' +
          '<button type="button" class="retry-submit">Click to retry</button>'
        );
      }
    });
  });

  $(document).on('click', '.retry-submit', function () {
    var form = $(this).closest('form');
    form.off('submit');
    form.submit(); // Shopify submit (captcha-safe)
  });
  
  // product page
  $('.site-nav-li').each(function(){
    if($(this).hasClass('active')) {
      var index = $(this).index() + 1;
      $('.site-nav-li:nth-child('+index+')').addClass('active');
      $(this).siblings('.site-nav-li').addClass('not-active');
    }
  });

  /* New thumbnail & main slider */
  let thumbsSwiper, mainSwiper;
  let ticking = false;

  function initSwipers() {
    if (thumbsSwiper) thumbsSwiper.destroy(true, true);
    if (mainSwiper) mainSwiper.destroy(true, true);

    const slideEls = Array.from(document.querySelectorAll('.product-i-images .swiper-slide'));
    const thumbSlides = Array.from(document.querySelectorAll('.product-i-thumbimages-s .swiper-slide'));
    const isMobile = window.matchMedia('(max-width:1023px)').matches;

    const productMainSlideWrapper = document.querySelector('.product-i-images .swiper-wrapper');
    if (productMainSlideWrapper) {
      productMainSlideWrapper.style.display = isMobile ? 'flex' : 'block';
    }

    if (isMobile) {
      // ---------- MOBILE MODE ----------
      mainSwiper = new Swiper('.product-i-images', {
        direction: 'horizontal',
        slidesPerView: 1, 
        loop: true, 
        allowTouchMove: true,
        pagination: { el: '.swiper-pagination', clickable: true },
      });

    } else {
      // ---------- DESKTOP MODE ----------
      thumbsSwiper = new Swiper('.product-i-thumbimages-s', {
        direction: 'vertical',
        slidesPerView: 5,
        spaceBetween: 5,
        freeMode: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
      });

      mainSwiper = new Swiper('.product-i-images', {
        direction: 'horizontal',
        slidesPerView: 1,
        allowTouchMove: true,
      });

      // ---------- SCROLL SYNC ----------
      function onScroll() {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(() => {
          const stickyOffset = 32;
          let activeIndex = 0;

          for (let i = 0; i < slideEls.length; i++) {
            const rect = slideEls[i].getBoundingClientRect();
            // if (rect.top <= stickyOffset + 10) activeIndex = i;
            // Trigger earlier than before
            if (rect.top <= stickyOffset + rect.height * 0.2) {
              activeIndex = i;
            }
          }

          if (mainSwiper.activeIndex !== activeIndex) {
            mainSwiper.slideTo(activeIndex, 0);
            setActiveThumb(activeIndex);
          }

          ticking = false;
        });
      }

      window.removeEventListener('scroll', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // ---------- THUMBNAIL CLICK (FIXED INDEX HANDLING) ----------
    thumbSlides.forEach((t, i) => {
      t.addEventListener('click', (e) => {
        e.preventDefault();

        // Use Swiper’s real index (accounts for looping, clones, etc.)
        const realIndex = t.dataset.swiperSlideIndex
          ? parseInt(t.dataset.swiperSlideIndex, 10)
          : i;

        if (isMobile) {
          mainSwiper.slideTo(realIndex);
        } else {
          const targetEl = slideEls[realIndex];
          if (!targetEl) return;

          const stickyOffset = 100;
          const top = window.scrollY + targetEl.getBoundingClientRect().top - stickyOffset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

          setTimeout(() => {
            mainSwiper.slideTo(realIndex, 0);
            setActiveThumb(realIndex);
          }, 200);
        }
      });
    });

    // ---------- INIT STATE ----------
    // setActiveThumb(0);

    function setActiveThumb(index) {
      thumbSlides.forEach((s, j) => {
        s.classList.toggle('active', j === index);
      });

      if (thumbsSwiper) {
        thumbsSwiper.slideTo(index);
        thumbsSwiper.activeIndex = index;
        thumbsSwiper.updateSlidesClasses();
      }
    }
  }

  window.addEventListener('load', initSwipers);
  window.addEventListener('resize', () => {
    clearTimeout(window._swiperResizeTimer);
    window._swiperResizeTimer = setTimeout(initSwipers, 250);
  });

  /* End new thumbnail & main slider */


  const zoomSlideEls = Array.from(document.querySelectorAll('.popup-zoomed-images .swiper-slide'));
  const zoomThumbSlides = Array.from(document.querySelectorAll('.popup-zoomed-thumb-images .swiper-slide'));

  // Initialize thumbnails
  var zoomGalleryThumbs = new Swiper(".popup-zoomed-thumb-images", {
    slidesPerView: 5,
    direction: "vertical",
    spaceBetween: 5
  });

  const zoomSlideWrapper = document.querySelector('.popup-zoomed-images .swiper-wrapper');
  if (zoomSlideWrapper) {
    zoomSlideWrapper.style.display = 'block';
  }

  // Zoom slider setup
  var productZSettings = {
    slidesPerView: 1,
    direction: "horizontal",
    loop:true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  var productZSlider = new Swiper('.popup-zoomed-images', productZSettings);

  function setZoomActiveThumb(index) {
    zoomGalleryThumbs.slideTo(index, 300);
    zoomGalleryThumbs.activeIndex = index;
    zoomGalleryThumbs.updateSlidesClasses();

    zoomThumbSlides.forEach((t, i) => {
      t.classList.toggle('swiper-slide-thumb-active', i === index);
    });
  }

  productZSlider.on('slideChange', function() {
    if ($(window).width() < 1024) {
      $('.product-zoomed-img').removeClass('slide-zoomed');
      $('.popup-zoomed-images').removeClass('zoomPopupScrollHide');
    }
    const activeIndex = productZSettings.activeIndex;
    setZoomActiveThumb(activeIndex);
  });


  // ---------- SCROLL SYNC (Fixed) ----------
  let zoomTicking = false;

  function zoomOnScroll() {
    if (zoomTicking) return;
    zoomTicking = true;

    window.requestAnimationFrame(() => {
      const stickyOffset = 32;
      let activeIndex = 0;

      const zoomWrapper = document.querySelector('.popup-zoomed-images');
      if (!zoomWrapper) return;

      const scrollTop = zoomWrapper.scrollTop;
      const wrapperRect = zoomWrapper.getBoundingClientRect();

      for (let i = 0; i < zoomSlideEls.length; i++) {
        const slide = zoomSlideEls[i];
        const rect = slide.getBoundingClientRect();

        const relativeTop = rect.top - wrapperRect.top + scrollTop;

        if (relativeTop <= scrollTop + stickyOffset + 10) {
          activeIndex = i;
        }
      }

      if (productZSlider.activeIndex !== activeIndex) {
        productZSlider.slideTo(activeIndex, 0);
        setZoomActiveThumb(activeIndex);
      }

      zoomTicking = false;
    });
  }

  const zoomWrapper = document.querySelector('.popup-zoomed-images');
  if (zoomWrapper) {
    zoomWrapper.addEventListener('scroll', zoomOnScroll, { passive: true });
  }

  zoomOnScroll();


  zoomThumbSlides.forEach((t, i) => {
    t.addEventListener('click', () => {
      const targetEl = zoomSlideEls[i];
      if (!targetEl) return;

      const zoomWrapper = document.querySelector('.popup-zoomed-images');
      if (!zoomWrapper) return;

      const wrapperRect = zoomWrapper.getBoundingClientRect();
      const targetRect = targetEl.getBoundingClientRect();
      const top = zoomWrapper.scrollTop + (targetRect.top - wrapperRect.top);

      zoomWrapper.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

      setTimeout(() => {
        productZSlider.slideTo(i, 0);
        setZoomActiveThumb(i);
      }, 150);
    });
  });

  $(document).on('click', '.product-i-images .swiper-slide', function () {
    var clickedIndex = this.getAttribute('data-swiper-slide-index')
      ? parseInt(this.getAttribute('data-swiper-slide-index'))
      : $(this).index();

    $('body').addClass('zoom-pop-opened');
    console.log('clickedIndex', clickedIndex);

    setTimeout(function () {
      document.querySelectorAll('.popup-zoomed-thumb-images .swiper-slide')[clickedIndex]?.click();
    }, 200);
  });

  // ---------- ZOOM CLICK TOGGLE ----------
  $(document).on('click', '.product-zoomed-img', function () {
    var $this = $(this);
    var img = $this.find('img');
    var aspectRatio = img.attr('img-height') / img.attr('img-width');
    var scrollOffset = aspectRatio * 750;
    var scrollTop = Math.abs($this.innerHeight() - scrollOffset);
    var scrollLeft = Math.abs($this.innerWidth() - 750);

    if ($this.hasClass('slide-zoomed')) {
      $this.removeClass('slide-zoomed');
      $this.parents('.popup-zoomed-images').removeClass('zoomPopupScrollHide');
    } else {
      setTimeout(function () {
        $this.addClass('slide-zoomed');
        $this.parents('.popup-zoomed-images').addClass('zoomPopupScrollHide');
        $this.scrollTop(scrollTop / 2);
        $this.scrollLeft(scrollLeft / 2);
      }, 300);
    }
  });

  
  $(document).on('click', '.collapse-tab-link', function(){
    $(this).addClass('active').siblings('.collapse-tab-link').removeClass('active');
    $('#'+$(this).attr('tab-id')).addClass('showed').siblings('.collapse-i-column').removeClass('showed');
  });
  
  if($(window).width() < 1024) {
    $(document).on('click', '.product-i-description .collapse-returns-link', function(){
      $(this).addClass('active').siblings('.collapse-returns-link').removeClass('active');
      $('#'+$(this).attr('tab-returns')).addClass('opend').siblings('.collapse-i-returns').removeClass('opend');
    });
  }

  $(document).on('click', '.clicktozoom', function(){
    var index = $(this).index() + 1;
    $('body').addClass('zoom-pop-opened');
  });

  $(document).on('click', '.popup-zoomed-images, .z-popup-close', function(){
    if($(this).is('.popup-zoomed-images')) {
      // if($(window).width() >= 1024) {       // Product zoom popup body event remove
      //   $('body').removeClass('zoom-pop-opened');
      // }
    } else {
      $('body').removeClass('zoom-pop-opened');
      $('.product-zoomed-img').removeClass('slide-zoomed');
      $('.popup-zoomed-images').removeClass('zoomPopupScrollHide');
      productZSlider.destroy(true, true);
      productZSlider = new Swiper('.popup-zoomed-images', productZSettings);
    }
  });

  /* Zoom popup close on ESC key */
  $(document).on('keydown', function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      if ($('body').hasClass('zoom-pop-opened')) {
        $('body').removeClass('zoom-pop-opened');
        $('.product-zoomed-img').removeClass('slide-zoomed');
        $('.popup-zoomed-images').removeClass('zoomPopupScrollHide');
        productZSlider.destroy(true, true);
        productZSlider = new Swiper('.popup-zoomed-images', productZSettings);
      }
    }
  });

  function adjustCenterMargin() {
    const slider = document.querySelector('.product-i-imagesContainer');
    const top = document.querySelector('.pro-description-first');
    const center = document.querySelector('.pro-description-sticky-two');
    const accordion = document.querySelector('.collapse-i2-desc.active');

    if (slider && top && center) {
      const imageHeight = slider.offsetHeight;
      const topHeight = top.offsetHeight;
      const marginBottom = parseInt(window.getComputedStyle(top).marginBottom) || 0;
      const centerHeight = center.offsetHeight;

      let accordionHeight = accordion ? accordion.scrollHeight : 0;

      // offset = (imageHeight - (topHeight + marginBottom + centerHeight + accordionHeight)) / 2
      let offset = (imageHeight - (topHeight + marginBottom + centerHeight + accordionHeight)) / 2;
      if (offset < 0) offset = 0;

      center.style.marginTop = offset + "px";
    }
  }

  $(document).on('click', '.collapse-i2-title', function(){
    $(this).toggleClass('active').parent('.collapse-i-column').siblings('.collapse-i-column').find('.collapse-i2-title').removeClass('active');
    $(this).next('.collapse-i2-desc').slideToggle(300).parents('.collapse-i-column').siblings('.collapse-i-column').find('.collapse-i2-desc').slideUp(300);
  });
  
  // Check if there's only one option and auto-select it
  $(document).ready(function() {
    if ($('.select-dropdown-wrap .optname').length === 1) {
      var firstOption = $('.select-dropdown-wrap .optname').first();
      firstOption.trigger('click');
    }
  });

  $(document).on('click', '.select-dropdown-box .optname', function(){
    $(this).parents('.select-dropdown-box').addClass('text-selected');
    $(this).parents('.select-dropdown-box').removeClass('active');
    // $(this).parents('.select-dropdown-list').slideUp();
    $(this).addClass('selected').siblings('.optname').removeClass('selected');
    $('#selectSizeDrawer .drawer-close').click();
    // $(this).parents('.select-dropdown-box').find('.select-dropdown-label').text($(this).text()).addClass('var-selected');
    var selectedSize = $(this).find('.opt-var-title').text().trim();
    $('.select-dropdown-box').find('.sBtn-text').html(selectedSize).addClass('var-selected');
    
    $('.add-cart-btn').removeClass('cart-disabled');
    $('.add-cart-btn').text('Add to Cart');

    $('.sticky-add-cart-btn').text('Add to Cart - ' + selectedSize);
    $('.sticky-select-size-btn').hide();
    $('.sticky-add-cart-btn').show();
    $('.add-cart-error').text('');

    var varid = $(this).attr('varid');
    var option1 = $(this).data('option1');
    var option2 = $(this).data('option2');
    var option3 = $(this).data('option3');
    if(option1 != undefined){
      $('#product-select-option-0').val(option1).trigger('change');
    }
    if(option2 != undefined){
      $('#product-select-option-1').val(option2).trigger('change');;
    }
    if(option3 != undefined){
      $('#product-select-option-2').val(option3).trigger('change');;
    }
    $('#product-select').val(varid);    
    var centerStickPos = setInterval(function(){
      stickyElement();
    }, 10);
    setTimeout(function(){
      clearInterval(centerStickPos);
    }, 300);
  });

  $('.select-dropdown-box').each(function(){
    var IHeight = $(this).find('.select-dropdown-wrap').innerHeight() + 2;
    if($(this).find('.select-dropdown-box span').hasClass('active')) {
      $('.select-dropdown-box').addClass('text-selected');  
    }
  });

 $(document).on('click', '#product-form .select-dropdown-label', function(){
    $("#product-form .select-dropdown-list").slideToggle();
    $(this).parents('.select-dropdown-box').toggleClass('sctbox-opened');
    var centerStickPos = setInterval(function(){
      stickyElement();
    }, 10);
    setTimeout(function(){
      clearInterval(centerStickPos);
    }, 300);
  });

  $(document).on('click', '.measure-info-toggle', function(){
    if($(this).hasClass('active')) {
      $(this).removeClass('active').find('.mesure-chn-txt').text('SIZE CHART');	
    } else {
      // $(this).addClass('active').find('.mesure-chn-txt').text('MEASUREMENTS BELOW IN CM');	
      $(this).addClass('active').find('.mesure-chn-txt').text('SIZE CHART');
      $('.measurment-info-desc .site-popup-link').removeClass('active');
      $('.measurment-info-desc .collapse-i2-content').hide();
    }
    
    $('.measurment-info-wrap').slideDown();
    setTimeout(function(){
      var measure_wrapper_height = $('.measurment-info-wrap').height();
      var measure_info_height = $('.measurment-info-desc').height();
      if(measure_info_height > measure_wrapper_height){
        $(".pro-description-sticky").css('height', measure_info_height + "px");
      }
    },400);
    var centerStickPos = setInterval(function(){
      stickyElement();
    }, 10);
    setTimeout(function(){
      clearInterval(centerStickPos);
    }, 300);
  });
  
  $(document).on('click', '.measure-info-toggle-close', function(){
    $(".measurment-info-wrap").slideUp();
    $(".pro-description-sticky").css('height', '');
  });

  /* Kiwi sizechart tab click */
  $(document).on('click', '.ks-tab-headers label', function(){
    $(".pro-description-sticky").css('height', '');
    setTimeout(function(){
      var measure_wrapper_height = $('.measurment-info-wrap').height();
      var measure_info_height = $('.measurment-info-desc').height();
      if(measure_info_height > measure_wrapper_height){
        $(".pro-description-sticky").css('height', measure_info_height + "px");
      }
    },200);
  });
  
  $(document).on('click', '.site-popup-link', function(){
    $('body').addClass('site-pop-opened');
    if($(window).width() >= 1024) {
      $('#'+$(this).attr('pop-id')).addClass('popup-opened');
    } else {
      if($(this).hasClass('close_link_popup active')){
        $(this).removeClass('active');
        $('.collapse-i2-content[content-id='+$(this).attr('pop-id')+']').slideUp();
      }else{
        $(this).addClass('active');
        $('.collapse-i2-content[content-id='+$(this).attr('pop-id')+']').slideDown();
      }
    }
  });

  $(document).on('click', '.site-popup-close, .collapse-i2-toggle', function(){
    $('body').removeClass('site-pop-opened');
    if($(window).width() >= 1024) {
      $('.site-i-product-popup').removeClass('popup-opened');
    } else {
      setTimeout(function(){
        $('.site-popup-link').removeClass('active');
      }, 400);
      $('.collapse-i2-content').slideUp(400);
    }
  });
  
  /* Size chart */ 
 /* var sizeChart = setInterval(function(){
    if($('.Sd_sizechartmodel').length == 0){
      $('.measurment-info-wrap').removeClass('product-has-size').addClass('product-hasnot-size');
    }
    else{
      clearInterval(sizeChart);
      $('.measurment-info-wrap').removeClass('product-hasnot-size').addClass('product-has-size');
    }
  },500);*/

  var sizeChart = setInterval(function(){
    if($('.ks-chart-container').length == 0){
      $('.measurment-info-wraps').removeClass('product-has-size').addClass('product-hasnot-size');
    }
    else{
      clearInterval(sizeChart);
      $('.measurment-info-wraps').removeClass('product-hasnot-size').addClass('product-has-size');
    }
  },500);
  
  
  if($(window).width() >= 1024) {  
    stickyElement();
    
    $(window).on('scroll', function(){
       setTimeout(function(){
         stickyElement();
      },1000);
    });
    $(window).on('resize', function(){
      stickyElement();
    });
  }
  
  function stickyElement() {
    $('.pro-description-sticky').each(function(){
      var $this = $(this);
      var firstDescTitle = $('.pro-description-first').innerHeight() / 2;
      var windowscroll = $(window).scrollTop();
      var windowscrollHead = $(window).scrollTop() + $('.site-i-header').innerHeight() + firstDescTitle;
      var offset = $(this).offset().top;
      var offsetHeight = $(this).offset().top + $(this).innerHeight();
      var stickoffset = ($(window).innerHeight() - $('.site-i-header').innerHeight() - $('.pro-description-first').innerHeight() - $(this).innerHeight()) / 2;
      if(stickoffset < 0)  {var stickoffset = 0;}
      var offsetsticky = windowscrollHead + $(this).innerHeight() + stickoffset;
      var offsetbottom = $('.product-info-section').offset().top + $('.product-info-section').innerHeight();
      // console.log('first_desc',$('.pro-description-first').innerHeight() / 2);      
      if($this.hasClass('pro-i2-desc')){
        var centerPosition = -(($this.height() / 2 - ($('.site-i-header').innerHeight() / 2)) - firstDescTitle) - 18;
      }else{
        var centerPosition = -(($this.height() / 2 - ($('.site-i-header').innerHeight() / 2)) - firstDescTitle);
      }

      $(this).css({ 'margin-top': centerPosition+'px' });

      if($(window).innerHeight() <= offsetHeight) {
        $(this).parents('.product-i-description').addClass('sticky-top');
      } else {
        $(this).parents('.product-i-description').removeClass('sticky-top');
      }
      
      offsetsticky >= offsetbottom ? $(this).parents('.product-i-description').addClass('sticky-bottom') : $(this).parents('.product-i-description').removeClass('sticky-bottom');
    });
  }
  
  var settings = {
    a11y: false,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 5,    
    breakpoints: {
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  }
  
  $(document).on('click', '.feature-slider-tab', function(){
    var sliderId = $('#'+$(this).attr('tab-id'));
    $(this).addClass('active').siblings('.feature-slider-tab').removeClass('active');
    $('#'+$(this).attr('tab-id')).addClass('slider-showed').siblings('.feature-product-slider').removeClass('slider-showed');
    var productFSlider = new Swiper(sliderId[0], settings);
    productFSlider.update(); 
  });
  
  $('.product-feature-tabs .feature-slider-tab').eq(0).trigger('click'); 

  
  $(document).on('click','.add-cart-btn',function(e){
    e.preventDefault();
    var $this = $(this);
    if(!$(this).parents('form').find('.sBtn-text').hasClass('var-selected')){
      // $(".add-cart-error").text('Select size to add to cart');
      // return false;
      $this.parents("form").find(".select-dropdown-list.hidden-x").slideDown(200);
      $this.parents("form").find(".select-dropdown-box").addClass('active');
      
      if (window.matchMedia("(max-width: 1024px)").matches) {
        $this
        .parents("form")
        .find(".select-btn.visible-x")
        .trigger("click");
      }
    }
    else{
      $this.addClass('adding');
      $('.sticky-add-cart-btn').addClass('adding');
      var form = $(this).parents('form');
      var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
      $.ajax({
        url: root_url + "/cart/add.js",
        type: "POST",
        data: form.serialize(),
        dataType: "json",
        success: function(){
          $.ajax({
            url: root_url + "/cart.js",
            type: "POST",
            dataType: "json",
            success: function(response){
              $.ajax({
                url: root_url + "/",
                dataType: "html",
                type: "get",
                success: function(data){
                  $this.removeClass('adding');
                  $('.sticky-add-cart-btn').removeClass('adding');
                  $this.text('Added to cart');
                  $('.sticky-add-cart-btn').text('Added to cart');
                  setTimeout(function(){
                    $this.text('Add one more');
                    $('.sticky-add-cart-btn').text('Add one more');
                  },4000);
                  var cartCount = $(data).find('.cart_count').html();
                  $('.cart_count').html(cartCount);
                  var cartCountMobile = $(data).find('.cart_count_mobile').html();
                  $('.cart_count_mobile').html(cartCountMobile);
                  var cartDrawerData = $(data).find(".sp-cart-drawer-content").html();
                  $(".sp-cart-drawer-content").html(cartDrawerData);
                  var cartCountDrawer = $(data).find('.cart_count_drawer').html();
                  $('.cart_count_drawer').html(cartCountDrawer);
                  $('.site-cart-icon').addClass('cart-pop-opened');
                  setTimeout( function(){$('.site-cart-icon').removeClass('cart-pop-opened');} , 5000);
                  setTimeout(function () {
                    $('#cart-drawer').addClass('open');
                    $('.drawer-backdrop').addClass('active');
                  }, 500);

                  setTimeout(function () {
                    $('#cart-drawer').removeClass('open');
                    $('.drawer-backdrop').removeClass('active');
                  }, 6000);

                }
              });         
            }
          });
        },
        error: function(jqXHR, textStatus, errorThrown){
          $this.removeClass('adding');
          $('.sticky-add-cart-btn').removeClass('adding');
          if(jqXHR.responseJSON.description != '') {
            if(jqXHR.responseJSON.status == '422'){
              $(".add-cart-error").text('All available sizes for this item already in your cart').show();
            }
            else{
              $(".add-cart-error").text(jqXHR.responseJSON.description).show();
            }
            setTimeout(function() { $(".add-cart-error").hide(); }, 3000);
          }
        }
      });
    }
  }); 

  /* collection page add to cart products */
  $(document).on('click','.btn-col-add', function(e){
    e.preventDefault();
    var $this = $(this);
    $this.addClass('adding');
    var varID = $(this).closest('.bc-pro-info').find(".size-toggle").data('id');
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    $.ajax({
      url: root_url + "/cart/add.js",
      type: "POST",
      data: {id:varID, quantity:1},
      dataType: "json",
      success: function(){
        $.ajax({
          url: root_url + "/cart.js",
          type: "POST",
          dataType: "json",
          success: function(response){
            $.ajax({
              url: root_url + "/",
              dataType: "html",
              type: "get",
              success: function(data){
                $this.removeClass('adding');
                $this.text('ADDED TO CART');
                var cartDrawerData = $(data).find(".sp-cart-drawer-content").html();
                $(".sp-cart-drawer-content").html(cartDrawerData);
                $('.site-cart-icon').addClass('cart-pop-opened');
               setTimeout( function(){$('.site-cart-icon').removeClass('cart-pop-opened');} , 5000);
              }
            });         
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown){
        $this.removeClass('adding');
        if(jqXHR.responseJSON.description != '') {
          if(jqXHR.responseJSON.status == '422'){
            $(".add-cart-error").text('All available sizes for this item already in your cart').show();
          }
          else{
            $(".add-cart-error").text(jqXHR.responseJSON.description).show();
          }
          setTimeout(function() { $(".add-cart-error").hide(); }, 3000);
        }
      }
    });
  }); 
  
  /* cart page */
  $(document).on('click','.qty-minus, .qty-plus', function(){
    var curr_val = $(this).parents('.cart-qty-box').find('input[type="number"]').val();
    var curr_id = $(this).parents('.cart-qty-box').find('.qty').attr('data-id');
    if($(this).attr('data') == 'minus') {
      if(curr_val != 0) {
        curr_val--;
      }
    }
    else {
      curr_val++;
    }

    $('.img-loader').show();
    cart_update(curr_id, curr_val);
  });
  
  $(document).on('click','.remove-item', function(e){
    e.preventDefault();
    var curr_id = $(this).attr('data-id');
    var curr_val = 0;
    cart_update(curr_id, curr_val);
  });

  $(document).on('click','.cart-items-remove', function(e){
    e.preventDefault();
    var curr_id = $(this).attr('data-id');
    var curr_val = 0;
    cart_update(curr_id, curr_val);
  });
  
  function cart_update(id, qty) {
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    $.ajax({
      type: 'POST',
      url: root_url + '/cart/change.js',
      dataType: 'json',
      data:{
        id:id,
        quantity:qty
      },
      success: function(data){
        $.ajax({
          url: root_url + '/cart',
          type: 'get',
          dataType: 'html',
          success: function(cartHTML) {
            var cartCount = $(cartHTML).find('.cart_count').html();
            $('.cart_count').html(cartCount);
            var cartCountMobile = $(cartHTML).find('.cart_count_mobile').html();
            $('.cart_count_mobile').html(cartCountMobile);
            var cartpage = $(cartHTML).find('.cart-html-content').html();
            $('.cart-html-content').html(cartpage);
            var cartCountDrawer = $(cartHTML).find('.cart_count_drawer').html();
            $('.cart_count_drawer').html(cartCountDrawer);
            var cartDrawerData = $(cartHTML).find(".sp-cart-drawer-content").html();
            $(".sp-cart-drawer-content").html(cartDrawerData);
            $('.img-loader').hide();
          }
        });
      }
    });
  }
  
  
    /*$('.cartqtyminus, .cartqtyplus').on('click',function(){
    var lineindex = $(this).data('lineindex');
    var current_value = parseInt($(this).closest('.cart-qty-box').find('.cart-qty-input').val());
    console.log('click');
    if($(this).data('func') == 'plus'){
      //  $(this).closest('.cart-qty-box').find('.cart-qty-input').val(current_value + 1);
      current_value = current_value + 1;
    }else{
      //  $(this).closest('.cart-qty-box').find('.cart-qty-input').val(current_value - 1);
      current_value = current_value - 1;
    }
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: { quantity: current_value, id: lineindex },
      success: function (data) {
        $.ajax({
          url: "/cart",
          dataType: "html",
          async: true,
          type: "get",
          success: function(data){       
            var cart_html = $(data).find('.cart-html-content').html();
            $('.cart-html-content').html(cart_html); 
          }
        });
      }
    });

  });*/
      
  if($(window).width() >= 1024) {
    /*$('.site-cust-links .site-cst-li:not(.site-search-icon)').hover(function(){
      $('body').addClass('noscroll');    
    }, function(){
      $('body').removeClass('noscroll');     
    });  */
    
    $(document).on('click', '.site-lvl3-link,.site-sub2-link', function(){
      $(this).addClass("active");
    });
  }
  
  $('.edit-address-icon').on('click', function(){
    var $this = $('#'+$(this).attr('data-form-id'));
    $this.toggle().parents().find('.edit-form-address').not($this).hide();
    $(this).parent(".edit-delete-icon").toggleClass("active").parents().find(".edit-delete-icon").not($(this).parent(".edit-delete-icon")).removeClass('active');
  });

  $(".address-cancel-btn").on('click', function(){
    var index_id = $(this).attr("data-form-id");
    $('#cust-address-form-'+index_id).hide();
    $('.edit-delete-icon[data-form-id='+ index_id +']').removeClass("active");
    
    if($(this).parents('.address-grid').find(".make_default_add").is(":visible") == false){
      $(this).parents('.address-grid').find(".make_default_add").show();
    }
    
    $('.address-grid').removeClass("no-opacity-address");
    $(this).parents('.address-grid').removeClass("no-opacity-address");
  });
  
  $(".new-add-link").on('click', function(){
    $(".new-address-form").toggleClass("active");
  });
  
  $(".cus-cancel-link").on('click', function(){
    $(".new-address-form").removeClass("active");
  });
  
  $(document).on('click', '.search_clear', function(){
    $(this).parents("form").find(".bc-sf-search-box").val("");
  });
  
  function stickyElement2() {
    $('.sticky-element').each(function(){
      var wscroll = $(window).scrollTop();
      var proffset = $('.sticky-parent').offset().top;
      var prheight = $('.sticky-parent').innerHeight();
      var proffset2 = proffset + prheight;
      var stheight = $(this).height();
      var wscroll2 = $(window).scrollTop() + $(this).innerHeight() + $('.site-i-header').innerHeight();
      
      var max = 0;
      wscroll2 >= proffset2 ? $(this).addClass('stick-bottom') : $(this).removeClass('stick-bottom');
      max = (stheight > max) ? stheight : max;
      $('.sticky-fixed-height').css({ 'min-height' : max});
    });
  }

  if($('.sticky-element').length > 0) {
    stickyElement2();
    $(window).on('scroll', function(){
      stickyElement2();
    });
  }

  /* address-page */
  var max = 0;
  $('.address-box').each(function() {
    var value = $(this).innerHeight();
    max = (value > max) ? value : max;
    $('.address-box').css({ 'min-height': max});
  });

  /* faq-page */
  if($(window).width() <= 767) {
    $('#f-a-q .rte > p, #terms-conditions .rte > p').each(function() {
      var $this = $(this);
      if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
        $this.addClass('remove-space');
    });
  }
  
  /* terms & condition page */  
  $(document).on('click','li[scroll-id], a[scroll-id]', function(e){
    e.preventDefault();
    var attr = $(this).attr('scroll-id');

    var extraSpacing = 20;

    if (window.matchMedia("(max-width: 1023px)").matches) {
        // mobile-specific adjustment
        extraSpacing = - 46;
    }

    var offset = $('#'+ attr).offset().top - $('.site-i-header').outerHeight(true) - $('.sticky-cus-links').outerHeight(true) - extraSpacing;

    $('html,body').animate({ scrollTop: offset }, 300);
  });
  
  if ($("#recently-viewed-products .product-i-item").length == 0){
    $('.product-feature-sliders').removeClass('mob-showd');
  }

  // Shop the rest, Select for you, More vendor, More type, Recently viewed
  var featureslider1 = new Swiper(".pro-feature-slider-1", {
    slidesPerView: 2,
    spaceBetween: 5,  
    breakpoints: { 
      767: {
        slidesPerView: 2,
      },
      1023: { 
        slidesPerView: 8,
      },
    },
  });

  var featureslider2 = new Swiper(".pro-feature-slider-2", {
    slidesPerView: 2,
    spaceBetween: 5,  
    breakpoints: { 
      767: {
        slidesPerView: 2,
      },
      1023: { 
        slidesPerView: 8,
      },
    },
  });

  var featureslider3 = new Swiper(".pro-feature-slider-3", {
    slidesPerView: 2,
    spaceBetween: 5,  
    breakpoints: { 
      767: {
        slidesPerView: 2,
      },
      1023: {  
        slidesPerView: 8,
      },
    },
  });
  // End Shop the rest, Select for you, More vendor, More type, Recently viewed
  
  if($(document).find('.shopify-email-marketing-confirmation__container').length){
    $(document).find('.shopify-email-marketing-confirmation__container').append('<a class="btn btn-border" href="/collections/new-arrivals">Continue shopping</a>');
  }

});

// cookies-sticky //
 function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  // function show_cookie_bar() {
  //   setTimeout(function(){
  //     $('.store-cookies').show();
  //   }, 2000);
  // }

  // $(document).ready(function(){

  //   var cname = "cookie_bar";
  //   var cookie_val = getCookie(cname);

  //   if(cookie_val == ''){
  //     show_cookie_bar()
  //   }

  //   $(document).on("click",'.close-cookies',function(){
  //     var cname = "cookie_bar";
  //     var cvalue = "visit";
  //     var exdays = "365";

  //     setCookie(cname, cvalue, exdays);
  //     $('.store-cookies').hide();
  //   });    
  // });

  // $(document).on("mouseover touchstart", ".bc-sf-filter-product-item", function(e) {
  //   // e.preventDefault();
  //   $('.bc-pro-info').not($(this).find('.bc-pro-info')).removeClass('col-sizepop-open');
  //   // $('.bc-pro-info').removeClass('col-sizepop-open');
  // });
  
  // $(document).on("click", ".bc-sf-filter-product-item .col-size-toggle", function(e) {
  //   e.preventDefault();
  //   var currText = $(this).text();
  //   var currVarId = $(this).data('id');
  //   $(this).closest('.bc-pro-info').find(".size-toggle").text(currText);
  //   $(this).closest('.bc-pro-info').find(".size-toggle").attr('data-id',currVarId);
  //   $(this).closest('.bc-pro-info').addClass("col-sizepop-open").siblings('.bc-pro-info').removeClass('col-sizepop-open');
  // });
  
  // $(document).on("click", ".bc-sf-filter-product-item .col-size-popup .col-close", function(e) {
  //   e.preventDefault();
  //   $(this).closest('.bc-pro-info').removeClass("col-sizepop-open");
  // });


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    this.elements.button.closest('.disclosure').classList.add('localize-drop-open');
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

/* Collection page */
// document.addEventListener('DOMContentLoaded', function () {
//   const content = document.querySelector('.collection-page .collapse-i-content');
//   const readMoreBtn = document.querySelector('.collection-page .col-collapse-content .read-more-btn');
//   if(readMoreBtn){
//     readMoreBtn.addEventListener('click', function () {
//       content.classList.toggle('show');
//       if (content.classList.contains('show')) {
//         readMoreBtn.textContent = '';
//       } else {
//         readMoreBtn.textContent = 'Read More';
//       }
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const collContent = document.querySelector('.collection-page .collapse-i-content');
  const btn = document.querySelector('.read-more-btn');

  if (!collContent || !btn) return;

  btn.addEventListener('click', function () { 
    collContent.classList.add('is-expanded');
    btn.style.display = 'none';
  });
});

/* Announcement bar */
if (document.querySelector('.announcement_bar')) {
  document.documentElement.classList.add('isAnnouceExists');
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.site-menu-live-chat').forEach(function(element) {
    element.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      document.querySelector('.site-menu-close').click();
       document.getElementById("shopify-chat").style.setProperty("display", "block", "important");
      document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();
      // document.getElementById("shopify-chat").css.display = "block";

    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.sticky-links li a');
  const currentURL = window.location.pathname;
  const linkContainer = document.querySelector('.sticky-links');
  let activeLink = null;
  links.forEach(link => {
    if (link.getAttribute('href') === currentURL) {
      link.classList.add('hello-active');
      activeLink = link;
    }
  });

  if (activeLink && linkContainer) {
    const linkLeft = activeLink.offsetLeft;
    let offset = 30;
    if (window.matchMedia('(max-width: 1023px)').matches) {
      offset = 23;
    } else if (window.matchMedia('(max-width: 1199px)').matches) {
      offset = 30;
    } else {
      offset = 30;
    }
    linkContainer.scrollTo({
      left: linkLeft - offset,
      behavior: 'smooth'
    });
  }

});

/* Homepage video autoplay */

// Select all video elements
const videos = document.querySelectorAll('.video-player');

// Ensure attributes required for autoplay
videos.forEach(video => {
  video.muted = true;
  video.playsInline = true;
  video.loop = true;
});
 
// IntersectionObserver options
const observerOptions = {
  threshold: 0.5 // 50% visible
};

// Observer callback
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const video = entry.target;

    if (entry.isIntersecting) {
      if (video.paused) {
        video.play().catch(err => console.log("Autoplay blocked:", err));
      }
    } else {
      if (!video.paused) {
        video.pause();
      }
    }
  });
}, observerOptions);

// Observe ALL videos
videos.forEach(video => {
  observer.observe(video);
});

setTimeout(function() {
  if (window.innerWidth <= 768) {
    document.body.style.overflow = "auto";
  }
}, 2000); // Overflow auto after 2 second in mobile

/* country & currency search in drawer */
document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('countrySearch');
  const countryList = document.getElementById('tab-location');
  const items = countryList.querySelectorAll('li');

  searchInput.addEventListener('input', function () {
    const filter = this.value.toLowerCase();

    items.forEach(function (item) {
      const text = item.textContent.toLowerCase();
      if (text.includes(filter)) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const storageKey = 'cookieConsent';

  // Select all checkbox groups (for popup + page)
  const checkboxes = document.querySelectorAll('.cookie-checkbox');
  const strictlyRequiredBoxes = document.querySelectorAll('.cookie-checkbox.strictly_required');
  const analyticsBoxes = document.querySelectorAll('.cookie-checkbox.analytics');
  const marketingBoxes = document.querySelectorAll('.cookie-checkbox.marketing');
  const functionalBoxes = document.querySelectorAll('.cookie-checkbox.functional');

  // Select all buttons by class (works for popup + page)
  const acceptSelectedBtns = document.querySelectorAll('.acceptSelected');
  const acceptAllBtns = document.querySelectorAll('.acceptAll');
  const customiseBtns = document.querySelectorAll('.customiseCookies');
  const modalCloseBtns = document.querySelectorAll('.modal-close');

  // Select popup + cookie bar
  const cookieBar = document.querySelector('.store-cookies');
  const cookiePopup = document.querySelector('#cookiePopup');

  // Load saved preferences
  const savedPreferences = JSON.parse(localStorage.getItem(storageKey)) || null;

  // Populate all checkboxes from saved data
  function syncCheckboxes(preferences) {
    analyticsBoxes.forEach(el => el.checked = preferences?.analytics || false);
    marketingBoxes.forEach(el => el.checked = preferences?.marketing || false);
    functionalBoxes.forEach(el => el.checked = preferences?.functional || false);
    strictlyRequiredBoxes.forEach(el => {
      el.checked = true;
      el.disabled = true;
    });
  }

  // Initialize on load
  syncCheckboxes(savedPreferences);

  // Save preferences (shared for all)
  function savePreferences(preferences) {
    localStorage.setItem(storageKey, JSON.stringify(preferences));
  }

  // Get current checkbox values
  function getCurrentPreferences() {
    const prefs = {
      strictly_required: true,
      analytics: analyticsBoxes[0]?.checked || false,
      marketing: marketingBoxes[0]?.checked || false,
      functional: functionalBoxes[0]?.checked || false
    };
    return prefs;
  }

  // Accept Selected (multiple buttons)
  acceptSelectedBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const prefs = getCurrentPreferences();
      savePreferences(prefs);
      cookieBar?.classList.remove('active');
      cookiePopup?.classList.remove('active');
      showConfirmation("Your cookie preferences have been saved.");
    });
  });

  // Accept All (multiple buttons)
  acceptAllBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      analyticsBoxes.forEach(el => el.checked = true);
      marketingBoxes.forEach(el => el.checked = true);
      functionalBoxes.forEach(el => el.checked = true);
      strictlyRequiredBoxes.forEach(el => el.checked = true);
      const prefs = getCurrentPreferences();
      prefs.analytics = prefs.marketing = prefs.functional = true;
      savePreferences(prefs);
      cookieBar?.classList.remove('active');
      cookiePopup?.classList.remove('active');
      showConfirmation("All cookies have been accepted.");
    });
  });

  // Customise button (open popup)
  customiseBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      cookiePopup?.classList.add('active');
    });
  });

  // Close popup
  modalCloseBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      cookiePopup?.classList.remove('active');
    });
  });

  // --- Small toast-style confirmation message ---
  function showConfirmation(message) {
    const toast = document.createElement("div");
    toast.textContent = message;
    toast.style.position = "fixed";
    toast.style.bottom = "25px";
    toast.style.right = "25px";
    toast.style.background = "#333";
    toast.style.color = "#fff";
    toast.style.padding = "10px 18px";
    toast.style.borderRadius = "6px";
    toast.style.fontSize = "14px";
    toast.style.zIndex = "9999";
    toast.style.opacity = "0";
    toast.style.transition = "opacity 0.3s ease";
    document.body.appendChild(toast);
    setTimeout(() => (toast.style.opacity = "1"), 100);
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 2500);
  }

  // 🔹 Show bar only if not accepted
  if (!savedPreferences) {
    cookieBar?.classList.add('active');
  }
});

/* Cookie preferance page */
// document.addEventListener('DOMContentLoaded', function () {
//   const savedPreferences = JSON.parse(localStorage.getItem('cookiePreferences')) || {};

//  document.getElementById('strictly_required').checked = savedPreferences['strictly_required'] || true; // This cookie can't be unchecked, so we default to 'true'.
//   const strictlyRequired = document.getElementById('strictly_required');
//   if (strictlyRequired) {
//     strictlyRequired.checked = savedPreferences['strictly_required'] ?? true;
//   }
//   document.getElementById('analytics_stat').checked = savedPreferences['analytics_stat'] || false;
//   document.getElementById('marketing').checked = savedPreferences['marketing'] || false;
//   document.getElementById('functional').checked = savedPreferences['functional'] || false;

//   function savePreferences() {
//       const preferences = {
//           strictly_required: document.getElementById('strictly_required').checked,
//           analytics_stat: document.getElementById('analytics_stat').checked,
//           marketing: document.getElementById('marketing').checked,
//           functional: document.getElementById('functional').checked,
//       };
//       localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
//   }

//   document.getElementById('acceptSelected').addEventListener('click', function () {
//       savePreferences();
//       console.log('Your selected preferences have been saved.');
//   });

//   document.getElementById('acceptAll').addEventListener('click', function () {
//       document.getElementById('strictly_required').checked = true;
//       document.getElementById('analytics_stat').checked = true;
//       document.getElementById('marketing').checked = true;
//       document.getElementById('functional').checked = true;
//       savePreferences();
//       console.log('All cookies have been accepted.');
//   });
// });

/* homepage new arrival autoplay */
// const newArrivalsection = document.querySelector('.new-arrival-section');
// if (section) {
//   let observer = new IntersectionObserver((entries, obs) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         newArrivalSlider.params.autoplay = { delay: 2000 };
//         newArrivalSlider.autoplay.start();
//         obs.disconnect();
//       }
//     });
//   }, { threshold: 0.3 });

//   observer.observe(newArrivalsection);
// }

/* Product page select dropdown click desktop */
// document.querySelectorAll('.select-btn.hidden-x').forEach(btn => {
//   btn.addEventListener('click', function () {
//     let parentBox = this.closest('.select-dropdown-box');
//     parentBox.classList.toggle('active');
//   });
// });

/* Product page select dropdown click desktop */
$(".select-btn.hidden-x").on("click", function(e) {
  e.stopPropagation();

  const $parentBox = $(this).closest(".select-dropdown-box");
  const $dropdownList = $parentBox.find(".select-dropdown-list.hidden-x");

  if ($parentBox.hasClass("active")) {
    $dropdownList.slideUp(200);
    $parentBox.removeClass("active");
  } else {
    $dropdownList.slideDown(200);
    $parentBox.addClass("active");
  }
});

$(document).on("click", function(e) {
  if (!$(e.target).closest(".size-button-wrapper").length) {
    $(".select-dropdown-list.hidden-x").slideUp(200);
    $(".select-dropdown-box").removeClass("active");
  }
});
/* End Product page select dropdown click desktop */



// document.querySelectorAll('.optname').forEach(opt => {
//   opt.addEventListener('click', function () {
//     let parentBox = this.closest('.select-dropdown-box');
//     parentBox.classList.remove('active');
//   });
// });

/* Product page sizechart drawer tabs click */
function triggerTab(index) {
  setTimeout(() => {
    $(".ks-tab-header").eq(index).trigger("click");
  }, 200);
}

$(document).on("click", ".eu-measurements", function() {
  // console.log("MEASUREMENTS");
  triggerTab(0); // MEASUREMENTS
  $(document).find('.drawer-measure-heading').show();
  $(document).find('.drawer-sizechart-heading').hide();
  $(document).find('.ks-tab-panel').eq(2).show();
});

$(document).on("click", ".virtual_fitting_room", function() {
  // console.log("how we measure");
  triggerTab(2); // HOW WE MEASURE
});

$(document).on("click", ".measure-info-toggle", function() {
  // console.log("SIZECHART");
  triggerTab(1); // SIZE CHART
  $(document).find('.drawer-measure-heading').hide();
  $(document).find('.drawer-sizechart-heading').show();
  $(document).find('.ks-tab-panel').eq(2).hide();
});

$(document).on("click",'.sticky-add-cart-btn', function() {
  console.log('sticky-add-cart-btn');
  $('.add-cart-btn').trigger('click');
});

/* Sticky button add to cart mobile */
$(window).on('scroll resize load', function () {
  var $addBtn = $('.add-cart-btn');
  var $stickyBtn = $('#size-sticky-btn');

  if ($addBtn.length) {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();

    var btnTop = $addBtn.offset().top;
    var btnBottom = btnTop + $addBtn.outerHeight();

    if (btnTop < windowBottom) {
      $stickyBtn.removeClass('fadeIn');
    } else {
      $stickyBtn.addClass('fadeIn');
    }

    // Check if button is visible in viewport
    // if (btnBottom > windowTop && btnTop < windowBottom) {
    //   $stickyBtn.removeClass('fadeIn');
    // } else {
    //   $stickyBtn.addClass('fadeIn');
    // }
  }
});
/* End sticky button add to cart mobile */

/* Header sticky on scroll down side */
// let lastScrollTop = 0;
// const header = document.querySelector(".site-i-header");
// const stickyClass = "header--sticky";

// window.addEventListener("scroll", function () {
//   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//   if (scrollTop > lastScrollTop) {
//     header.classList.add(stickyClass);
//     document.body.classList.add('full-header-sticky');
//   } else {
//     header.classList.remove(stickyClass);
//     document.body.classList.remove('full-header-sticky');
//   }

//   lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
// });

let lastScrollTop = 0;
let upScrolled = 0;

const header = document.querySelector(".site-i-header");
const stickyClass = "header--sticky";
 
const downOffset = 50;   // sticky lagne ke liye
const removeAfterUp = 400; // ⬆️ itna upar scroll ke baad remove 

window.addEventListener("scroll", function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // SCROLL DOWN → ADD STICKY
  if (scrollTop > lastScrollTop) {
    upScrolled = 0; // reset
    if (scrollTop > downOffset) {
      header.classList.add(stickyClass);
      document.body.classList.add("full-header-sticky");
    }
  }

  // SCROLL UP → COUNT DISTANCE
  if (scrollTop < lastScrollTop) {
    upScrolled += lastScrollTop - scrollTop;

    if (upScrolled >= removeAfterUp) {
      header.classList.remove(stickyClass);
      document.body.classList.remove("full-header-sticky");
    }
  }

  // TOP SAFETY
  if (scrollTop <= downOffset) {
    header.classList.remove(stickyClass);
    document.body.classList.remove("full-header-sticky");
    upScrolled = 0;
  }

  lastScrollTop = scrollTop;
});





$('.search-menu-icon').on('click', function() {
    $('.search-drawer-wrapper').find('input[name="q"]').focus();
});

$('.pro-shipping-info-link').on('click', function() {
    $('.search-drawer-wrapper').find('input[name="q"]').focus();
});

$(document).on('click', '.pro-shipping-info-link', function () {
  const $link = $(this);
  const drawerId = $link.data('drawer');
  const $drawer = $('#' + drawerId);

  if (!$drawer.length) return;

  setTimeout(function () {
    if ($drawer.hasClass('open')) {
      $link.addClass('active');
    } else {
      $link.removeClass('active');
    }
  }, 10);
});


document.addEventListener("click", function (e) {
    const link = e.target.closest('a[href="/pages/newsletter"]');

    if (link) {
        e.preventDefault(); // page redirect stop

        const trigger = document.querySelector('[data-drawer="newsletter-drawer"]');
        if (trigger) {
            trigger.click(); // trigger click
        }
    }
});














// document.addEventListener('DOMContentLoaded', function () {
//   if (!window.matchMedia('(min-width:1024px)').matches) return;
//   const left = document.querySelector('.product-i-imagesContainer');
//   if (!left) return;
//   let hoverLeft = false;
//   let currentScroll = 0;
//   let targetScroll = 0;
//   let raf = null;
//   const SPEED = 0.9;
//   const EASING = 0.12;
//   function lockBody() {
//     document.body.classList.add('image-scroll-lock');
//   }
//   function unlockBody() {
//     document.body.classList.remove('image-scroll-lock');
//   }
//   left.addEventListener('mouseenter', () => {
//     hoverLeft = true;
//     currentScroll = left.scrollTop;
//     targetScroll = currentScroll;
//   });
//   left.addEventListener('mouseleave', () => {
//     hoverLeft = false;
//     unlockBody();
//     cancelAnimationFrame(raf);
//   });
//   function animate() {
//     currentScroll += (targetScroll - currentScroll) * EASING;
//     left.scrollTop = currentScroll;

//     if (Math.abs(targetScroll - currentScroll) > 0.5) {
//       raf = requestAnimationFrame(animate);
//     }
//   }
//   document.addEventListener('wheel', function (e) {
//     if (!hoverLeft) return;
//     const maxScroll = left.scrollHeight - left.clientHeight;
//     const atTop = left.scrollTop <= 0 && e.deltaY < 0;
//     const atBottom = left.scrollTop >= maxScroll && e.deltaY > 0;    
//     if (atTop || atBottom) {
//       unlockBody();
//       return;
//     }    
//     lockBody();
//     e.preventDefault();
//     targetScroll += e.deltaY * SPEED;
//     targetScroll = Math.max(0, Math.min(maxScroll, targetScroll));
//     if (!raf) animate();
//   }, { passive: false });
// });





if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    document.body.classList.add('is-safari');
}








document.addEventListener("click", function(e){
  if(e.target.closest(".pro-shipping-info-link")){
    document.querySelectorAll("input, textarea").forEach(function(el){
      el.blur();
    });
  }
});








document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".site-ft-title").forEach(function (title) {

    title.addEventListener("click", function () {

      const block = this.closest(".site-ft-blocks");

      // थोड़ा delay ताकि theme पहले accordion open कर दे
      setTimeout(function () {

        const content = block.querySelector(".site-ft-content");

        // अगर open है तभी scroll करें
        if (window.getComputedStyle(content).display !== "none") {

          block.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });

        }

      }, 300); // 300ms animation delay
    });

  });

});
